export default "__VITE_ASSET__8b14283f__"